<app-header [isScrolled]="true"></app-header>
<ion-content>
  <div class="b2b-banner">
    <div style="position: absolute; width: 100%; height: 100%; left: 0; top: 0;">
      <div class="b2b-text" style="color: white">
        <span>Property Investment & Management Company</span>
        <h1>
          <div>Property Management</div>
          Greater Returns
        </h1>
        <p>Premier property management for long-term rentals across Riyadh</p>
      </div>
    </div>
  </div>
  <article class="article">
    <ion-row>
      <ion-col size-lg="6" size="12">
        <app-contact-details></app-contact-details>
      </ion-col>
      <ion-col size-lg="6" size="12">
        <app-contact-form [b2bOnly]="true" [formType]="formType"></app-contact-form>
      </ion-col>
    </ion-row>
  </article>

  <app-b2b-section></app-b2b-section>
  <app-footer></app-footer>
</ion-content>
